<template>
  <div class="text-center">
    <b-alert variant="danger" show v-if="errors">{{errors}}</b-alert>
    <b-alert variant="danger" show v-if="veeErrors && veeErrors.items && veeErrors.items.length">Verifique os requisitos acima antes de continuar</b-alert>
    <div>
      <button v-if="sending" type="button" class="btn btn-default btn-block"><i class="fa fa-spinner fa-spin"></i> Enviando dados...</button>
      <button v-if="!sending && onCancel" @click="onCancel()" type="button" class="btn btn-secondary btn-block" >Cancelar</button>
      <button v-if="!sending" role="button" class="btn btn-primary btn-block">{{label ? label : 'Salvar'}}</button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'form-submit',
  props: ['errors', 'sending', 'label', 'icon', 'onCancel']
};
</script>
